import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: !!localStorage.getItem('token'),
    memberInfo: localStorage.getItem('memberInfo') ? JSON.parse(localStorage.getItem('memberInfo')) : {},
    tags: localStorage.getItem('tags') ? JSON.parse(localStorage.getItem('tags')) : [],
	isMockLogin:'',
    robotId: localStorage.getItem('robotId') ? localStorage.getItem('robotId') : '',
    robotName: localStorage.getItem('robotName') ? localStorage.getItem('robotName') : '',
    brand: {
      name: '', // 品牌名称
      slogan: '' // 品牌口号
    },
    selectedIndustryId: null, // 选择的行业id
    selectedStyleId: null, // 选择的风格id
    selectedColorId: null, // 选择的颜色id
    otherIndustry: '', // 新增的状态，用于其他行业输入
    otherColor: '', // 新增状态，用于存储其他颜色
  },
  mutations: {
    setLogin(state,isLogin){
      state.isLogin = isLogin
    },
    setMemberInfo(state, info) {
      state.memberInfo = info
    },
    setTags(state, tags) {
      state.tags = tags
      localStorage.setItem('tags', JSON.stringify(state.tags))
    },
    pushTags(state, tag) {
      if(!state.tags.includes(tag)){
        state.tags.unshift(tag)
      }
      localStorage.setItem('tags', JSON.stringify(state.tags))
    },
    deleteTags(state, index){
      state.tags.splice(index,1)
      localStorage.setItem('tags', JSON.stringify(state.tags))
    },
    setIsMockLogin(state, val){
      state.IsMockLogin=val
    },
    setRobotId(state, id) {
      state.robotId = id
    },
    setRobotName(state, name) {
      state.robotName = name
    },
    SET_BRAND_NAME(state, name) {
      state.brand.name = name
    },
    SET_SLOGAN(state, slogan) {
      state.brand.slogan = slogan
    },
    setSelectedIndustryId(state, id) {
      state.selectedIndustryId = id;
    },
    setSelectedStyleId(state, id) {
      state.selectedStyleId = id;
    },
    setSelectedColorId(state, id) {
      state.selectedColorId = id;
    },
    SET_OTHER_INDUSTRY(state, industry) {
      state.otherIndustry = industry; // 用于其他行业的 mutation
    },
    SET_OTHER_COLOR(state, color) {
      state.otherColor = color; // 用于其他颜色的 mutation
    },
  },
  actions: {
    setBrandName({ commit }, name) {
      commit('SET_BRAND_NAME', name)
    },
    setSlogan({ commit }, slogan) {
      commit('SET_SLOGAN', slogan)
    },
    updateSelectedIndustryId({ commit }, id) {
      commit('setSelectedIndustryId', id);
    },
    updateSelectedStyleId({ commit }, id) {
      commit('setSelectedStyleId', id);
    },
    updateSelectedColorId({ commit }, id) {
      commit('setSelectedColorId', id);
    },
    updateOtherIndustry({ commit }, industry) {
      commit('SET_OTHER_INDUSTRY', industry); // 用于其他行业的 action
    },
    updateOtherColor({ commit }, color) {
      commit('SET_OTHER_COLOR', color); // 用于其他颜色的 action
    },
  },
  getters:{
    isLogin: state => state.isLogin,
    memberInfo: state => state.memberInfo,
	tags: state => state.tags,
    robotId: state => state.robotId,
    robotName: state => state.robotName,
  },
  modules: {
  }
})
